import type React from "react";
import type { ReactNode } from "react";
import "./style.css";

interface Props {
	type: "info" | "error" | "warning" | "success";
	children: ReactNode;
}

export const SimpleResult: React.FC<Props> = ({ type, children }: Props) => {
	return (
		<div className={`t4-simple-result text-center text-lg ${type}`}>
			{children}
		</div>
	);
};
